var els = $('form[data-payouts-form]');
if (els.length > 0) {
  require.ensure('../controllers/stripe_connect_controller', function(require) {
    var StripeConnectController = require('../controllers/stripe_connect_controller');
    els.each(function() {
      return new StripeConnectController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/stripe.initializer.js